import { TranslateLoader } from 'ng2-translate/ng2-translate';
import { Observable } from 'rxjs/Rx';
import { AppSettings } from '../sharedcomponents/_common/constants/app.constants';
// import {langTranslate} from '../_services/translateService';
import { Http, Headers, RequestOptions } from '@angular/http';
export class CustomLoader implements TranslateLoader {
  // lblFinalString:any;

  constructor(private http: Http) {}
  getTranslation(lang: string): Observable<any> {
    let labelData: any;
    let lblString = '';

    return Observable.create(observer => {
      // if (sessionStorage.langCode != lang || sessionStorage.lblFinalString == undefined || sessionStorage.lblFinalString == null || sessionStorage.lblFinalString == '') {
          this.gettranslateLabelservice(lang).subscribe(data => {
          labelData = this.getArray(data.AppLabels[0].ScreensLabels);
          labelData.forEach(element => {
            const lblArray = this.getArray(element.Labels);
            lblArray.forEach(lblInfo => {
              const lblValue = lblInfo.LabelText.replace(/"/g, '')
                .replace(/\r\n/g, '')
                .replace('\n', '');
              lblString += `"${element.ScreenCode.trim()}_${lblInfo.LabelCode.trim()}":"${lblValue.trim()}",`;
            });
          });
          // let x = `{${lblString.slice(0, -1)}}`;
          const lblFinalString = `{${lblString.slice(0, -1).replace('\n', '')}}`;
          sessionStorage.tuorialLink = data.MainTutorialLink;
          sessionStorage.lblFinalString = lblFinalString;
          observer.next(JSON.parse(lblFinalString));
          observer.complete();
        });
      // } else {
      //   observer.next(JSON.parse(sessionStorage.lblFinalString));
      //   observer.complete();
      // }
    });
  }
  getArray(obj) {
    try {
      if (!(Object.prototype.toString.call(obj) === '[object Array]')) {
        let arrCol = [];
        arrCol.push(obj);
        return arrCol;
      } else return obj;
    } catch (error) {
      return [];
    }
  }
  restPost(envelop: string, SOAPurl: string) {
    const headers: Headers = new Headers();
    if (SOAPurl.indexOf('ICEMaster') > 0) {
      headers.append('App_key', '300323db-c982-4e96-90f0-5626920e18a4');
    }
    headers.append('Content-Type', 'application/json; charset=utf-8');
    const options = new RequestOptions({ headers: headers }); // Create a request option
    return this.http
      .post(SOAPurl, envelop, options)
      .map(res => {
        const data: any = res;
        if (data._body == '' || data._body == null) {
          return { data };
        } else {
          return data.json();
        }
      })
      .last();
    // .catch(this.handleError);
  }
  gettranslateLabelservice(langCode) {
    return this.restPost(this.gettranslateLabelenvolpe(langCode), AppSettings.ICEMasterService + '/GetLabelForEachLanguage');
  }
  gettranslateLabelenvolpe(langCode) {
    const envelope = `{
                "LanguageCode":"${langCode}",
                "Platform":"MOBILE",
                "ApplicationType":"ANDROID",
                "UpdatedTimeStamp": ""
                 }`;
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/Translate/customtranslate.ts